module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/icon_arrow-c3bab1cebf119e234df5e9525807bf39.svg";